/**
 * WebSerial type definitions
 */

export type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'error'

// Transfer settings for Teensy 4.1
// Teensy 4.1 can handle 20-25 MB/s sustained via High-Speed USB 2.0 (480 Mbps)
// - USB packet size is 512 bytes, internal buffer is 6KB (12 x 512)
// - Use large chunks aligned to 512-byte USB packets
// - Minimal delays since Teensy's USB stack is fast
export const TEENSY_CHUNK_SIZE = 16384  // 16KB chunks (32 USB packets)

// Legacy settings for fallback (conservative for compatibility)
export const SERIAL_CHUNK_SIZE = 128     // Small chunks for slower devices
export const SERIAL_CHUNK_DELAY = 5      // 5ms delay between chunks

// Device detection helpers
export const TEENSY_VENDOR_ID = 0x16C0   // PJRC vendor ID
